import React from 'react';


export const SequenceLabelItem = ({label, clickCardAction, activeIndex, reqAct, handleClickCard}) => {
  if (!label) return null;

  return (
    <div className={"PreflopCharts__chart-sequence-card" + ((!label.id) ? ' not-found' : '')}
         onClick={() => handleClickCard(label)}>
      <div className={"PreflopCharts__chart-sequence-card-wrapper"}>
        {!label.id && <div className={"PreflopCharts__chart-sequence-card-wrapper-notfound"}>Good Luck!</div>}
        {label.id && <>
          <div className={"PreflopCharts__chart-sequence-card-wrapper-header"}>
            <div>{label.position}</div>
            <div>{label.stack ?? ''}</div>
          </div>
          <div className={"PreflopCharts__chart-sequence-card-wrapper-actions"}>
            {label.available_actions && label.available_actions.map((action) => {
              return (
                <div key={action.type}
                     className={(reqAct[activeIndex] === action.type ? 'active' : '')}
                     onClick={(event) => {
                       event.stopPropagation();
                       clickCardAction(action, label)
                     }}
                >{action.label}
                </div>
              );
            })}
          </div>
        </>
        }
      </div>
    </div>
  );
}